import { queryOptions } from '@tanstack/react-query';

import { McpTokenService } from '../service/McpTokenService';

const mcpTokensQueries = {
  all: () => ['mcp-tokens'] as const,
  list: (workspaceId: string) =>
    queryOptions({
      queryKey: [...mcpTokensQueries.all(), workspaceId],
      queryFn: () => McpTokenService.list(workspaceId),
      enabled: Boolean(workspaceId),
    }),
};

export { mcpTokensQueries };
